import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from './contexts/AuthContext';
import { CondominioProvider } from './contexts/CondominioContext';
import { NotificationProvider } from './components/NotificationSystem';
import './styles/custom.css';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Condominios from './pages/Condominios';
import Apartamentos from './pages/Apartamentos';
import Moradores from './pages/Moradores';
import Fornecedores from './pages/Fornecedores';
import AreasComuns from './pages/AreasComuns';
import Reservas from './pages/Reservas';
import Garagens from './pages/Garagens';
import Funcionarios from './pages/Funcionarios';
import Visitantes from './pages/Visitantes';
import Encomendas from './pages/Encomendas';
import ConfirmarEntregaEncomenda from './pages/ConfirmarEntregaEncomenda';
import Ocorrencias from './pages/Ocorrencias';
import Veiculos from './pages/Veiculos';
import Comunicados from './pages/Comunicados';
import Usuarios from './pages/Usuarios';
import VincularUsuario from './pages/VincularUsuario';
import Relatorios from './pages/Relatorios';
import Perfil from './pages/Perfil';
import Pets from './pages/Pets';
import AchadosPerdidos from './pages/AchadosPerdidos';
import FaleConosco from './pages/FaleConosco';
import Documentos from './pages/Documentos';
import Agenda from './pages/Agenda';
import NotasFiscais from './pages/NotasFiscais';
import Balancetes from './pages/Balancetes';
import AlterarSenha from './pages/AlterarSenha';
import AlterarSenhaUsuario from './pages/AlterarSenhaUsuario';
import TrocarSenhaObrigatoria from './pages/TrocarSenhaObrigatoria';
import DefinirSenha from './pages/DefinirSenha';
import EsqueceuSenha from './pages/EsqueceuSenha';
import SolicitarAcesso from './pages/SolicitarAcesso';
import Cadastro from './pages/Cadastro';
import Configuracoes from './pages/Configuracoes';
import ConfiguracoesGerais from './pages/ConfiguracoesGerais';
import ConfiguracoesPerfil from './pages/ConfiguracoesPerfil';
import Parametros from './pages/Parametros';
import MeusBoletos from './pages/MeusBoletos';
import CobrancasCondominio from './pages/CobrancasCondominio';
import Votacoes from './pages/Votacoes';
import VotacaoForm from './pages/VotacaoForm';
import Contratos from './pages/Contratos';
import SindicoCondominio from './pages/SindicoCondominio';
import MeusCondominios from './pages/MeusCondominios';
import MeuCondominio from './pages/MeuCondominio';
import LoadingSpinner from './components/LoadingSpinner';
import PoliticaPrivacidade from './pages/PoliticaPrivacidade';
import ExclusaoConta from './pages/ExclusaoConta';

function App() {
  const { user, loading } = useAuth();

  if (loading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    return (
      <NotificationProvider>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/cadastro" element={<Cadastro />} />
          <Route path="/definir-senha" element={<DefinirSenha />} />
          <Route path="/esqueceu-senha" element={<EsqueceuSenha />} />
          <Route path="/solicitar-acesso" element={<SolicitarAcesso />} />
          <Route path="/fale-conosco" element={<FaleConosco />} />
          {/* Páginas públicas exigidas por Play Store / App Store (sem login) */}
          <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
          <Route path="/exclusao-conta" element={<ExclusaoConta />} />
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </NotificationProvider>
    );
  }

  if (user?.trocar_senha) {
    return (
      <NotificationProvider>
        <Routes>
          <Route path="*" element={<TrocarSenhaObrigatoria />} />
        </Routes>
      </NotificationProvider>
    );
  }

  return (
    <NotificationProvider>
      <CondominioProvider>
        <Layout>
          <Routes>
            <Route path="/" element={<Navigate to="/dashboard" replace />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/condominios" element={<Condominios />} />
            <Route path="/condominios/sindico" element={<SindicoCondominio />} />
            <Route path="/meus-condominios" element={<MeusCondominios />} />
            <Route path="/meu-condominio" element={<MeuCondominio />} />
            <Route path="/apartamentos" element={<Apartamentos />} />
            <Route path="/moradores" element={<Moradores />} />
            <Route path="/fornecedores" element={<Fornecedores />} />
            <Route path="/areas-comuns" element={<AreasComuns />} />
            <Route path="/reservas" element={<Reservas />} />
            <Route path="/garagens" element={<Garagens />} />
            <Route path="/funcionarios" element={<Funcionarios />} />
            <Route path="/visitantes" element={<Visitantes />} />
            <Route path="/encomendas" element={<Encomendas />} />
            <Route path="/encomendas/:id/confirmar-entrega" element={<ConfirmarEntregaEncomenda />} />
            <Route path="/ocorrencias" element={<Ocorrencias />} />
            <Route path="/veiculos" element={<Veiculos />} />
            <Route path="/comunicados" element={<Comunicados />} />
            <Route path="/usuarios" element={<Usuarios />} />
            <Route path="/usuarios/:id/vinculos" element={<VincularUsuario />} />
            <Route path="/usuarios/:id/senha" element={<AlterarSenhaUsuario />} />
            <Route path="/relatorios" element={<Relatorios />} />
            <Route path="/perfil" element={<Perfil />} />
            <Route path="/pets" element={<Pets />} />
            <Route path="/achados-perdidos" element={<AchadosPerdidos />} />
            <Route path="/fale-conosco" element={<FaleConosco />} />
            <Route path="/documentos" element={<Documentos />} />
            <Route path="/agenda" element={<Agenda />} />
            <Route path="/notas-fiscais" element={<NotasFiscais />} />
            <Route path="/balancetes" element={<Balancetes />} />
            <Route path="/votacoes" element={<Votacoes />} />
            <Route path="/votacoes/nova" element={<VotacaoForm />} />
            <Route path="/votacoes/:id/editar" element={<VotacaoForm />} />
            <Route path="/contratos" element={<Contratos />} />
            <Route path="/financeiro/cobrancas" element={<CobrancasCondominio />} />
            <Route path="/meus-boletos" element={<MeusBoletos />} />
            <Route path="/alterar-senha" element={<AlterarSenha />} />
            <Route path="/politica-privacidade" element={<PoliticaPrivacidade />} />
            <Route path="/exclusao-conta" element={<ExclusaoConta />} />
            <Route path="/configuracoes" element={<Configuracoes />} />
            <Route path="/configuracoes/gerais" element={<Configuracoes />} />
            <Route path="/configuracoes/perfil" element={<Configuracoes />} />
            <Route path="/configuracoes/importar" element={<Configuracoes />} />
            <Route path="/configuracoes/parametros" element={<Parametros />} />
            <Route path="/login" element={<Navigate to="/dashboard" replace />} />
            <Route path="*" element={<Navigate to="/dashboard" replace />} />
          </Routes>
        </Layout>
      </CondominioProvider>
    </NotificationProvider>
  );
}

export default App;
